import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { FormErrorComponent } from '@shared/components';
import { RequiredLabelDirective } from '@shared/directives';
import { FormGroupOf, ActivateAccountRequest } from '@shared/models';
import { AuthService, ToastsService } from '@shared/services';
import { FormGenerator, FormGroupExtension } from '@shared/utils';

import { AuthCardComponent } from '../auth-card/auth-card.component';

@Component({
  templateUrl: './activate-account.component.html',
  imports: [
    ...COMMON_STANDALONE_IMPORTS,
    PasswordModule,
    FormErrorComponent,
    RequiredLabelDirective,
    AuthCardComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivateAccountComponent implements OnInit {
  activateAccountComponentLoader = 'activateAccountComponentLoader';

  editForm: FormGroup<FormGroupOf<ActivateAccountRequest>> = FormGenerator.initActivateAccountForm(this.translate);

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private toastsService: ToastsService
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const email = this.activatedRoute.snapshot.queryParamMap.get('email');
    this.editForm = FormGenerator.initActivateAccountForm(
      this.translate,
      new ActivateAccountRequest(email, null, token)
    );
  }

  onSubmit(): void {
    if (FormGroupExtension.hasAnyValidationError(this.editForm)) {
      FormGroupExtension.markFormAsDirtyAndTouched(this.editForm);
      this.translate.instant('error.invalidForm');
      return;
    }
    this.authService.activateAccount(this.activateAccountComponentLoader, this.editForm.getRawValue()).subscribe({
      next: () => {
        this.toastsService.showSuccess(this.translate.instant('auth.activateAccount.isActivated'));
      },
      error: (error) => this.toastsService.showError(error),
    });
  }
}
